<template>
  <div id="sig-container" class="full form-horizontal">
    <div class="loader" v-if="loading || loading_file">
      <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
    </div>
    <contacto @like-contacto="likeContacto(contacto)" />
    <div class="lead text-center m-3" v-if="buscando_obligaciones">
      Cargando obligaciones, por favor espere...
    </div>
    <table-component
      :data="obligaciones"
      @click-event="clickEvent"
      v-if="!buscando_obligaciones"
      :componentName="'InformacionContacto'"
    >
      <table-column
        slot="label"
        :label="'Obligación'"
        v-bind:value="'identificador_obligacion'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Fecha Pago garantia'"
        v-bind:value="'fecha_inicio_mora'"
        :filter="'formatDate'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Cliente'"
        v-bind:value="'informacion_adicional.nombre_banco'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Casa de Cobranza'"
        v-bind:value="'nombre'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Saldo Capital'"
        v-bind:value="'saldo_capital'"
        :filter="'numberFormat'"
        :customClass="'text-right'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Intereses FGA'"
        v-bind:value="'interes_fga'"
        :filter="'numberFormat'"
        :customClass="'text-right'"
      ></table-column>
      <table-column
        slot="label"
        :label="'Saldo Real'"
        v-bind:value="'saldo_real'"
        :filter="'numberFormat'"
        :customClass="'text-right'"
      ></table-column>
      <table-column slot="label" :label="'Acciones'" :icon="'fa'">
        <template
          slot="icon"
          :icon="'fa fa-search'"
          :class="'btn btn-sm btn-info'"
          :slug="'detalle-obligacion'"
          :tooltip="'Ver detalle obligación'"
        ></template>
        <template
          slot="icon"
          :icon="'fa fa-life-ring'"
          :class="'btn btn-sm btn-info'"
          :slug="'paz-salvo'"
          :tooltip="'Generar paz y salvo'"
        ></template>
        <template
          slot="icon"
          :icon="'fa fa-folder-open'"
          :class="'btn btn-sm btn-info'"
          :slug="'certificado-deuda'"
          :tooltip="'Generar certificado de cuenta'"
        ></template>
      </table-column>
    </table-component>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FileSaver from "file-saver";

export default {
  name: "InformacionContacto",
  data: () => {
    return {
      buscando_obligaciones: false,
      loading_file: false,
    };
  },
  computed: {
    ...mapGetters({
      deudor: "deudor/deudor",
      loading: "loading",
      obligaciones: "deudor/obligaciones",
    }),
  },
  components: {
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn"),
    Contacto: () => import("@/views/Contacto.vue"),
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  methods: {
    getDeudor(documento) {
      this.$store
        .dispatch("index", {
          endpoint: "deudor",
          params: { identificacion: documento },
        })
        .then((response) => {
          if (response.datos.length > 0) {
            this.$store.dispatch("deudor/refresh_deudores", response.datos);
            this.deudorObligaciones(response.datos[0].id);
            if (!this.contactos) {
              this.getInformacionContacto(response.datos[0].id);
            }
          } else {
            this.$router.push({ path: "/" });
            this.$notify({
              title: "Advertencia!",
              type: "warning",
              content:
                "No se encontró información con el documento " + documento,
            });
          }
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "Se ha presentado un error realizando su consulta",
          });
        });
    },
    getInformacionContacto(documento) {
      this.$store
        .dispatch("index", {
          endpoint: "contacto",
          params: { deudor_id: documento },
        })
        .then((response) => {
          this.$store.dispatch("gestion/refreshInfoContacto", response);
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content:
              "Se ha presentado un error consultando la información de contacto",
          });
        });
    },
    async deudorObligaciones(deudor_id) {
      this.buscando_obligaciones = true;
      this.$store.dispatch("deudor/refresh_obligaciones", []);
      this.$store
        .dispatch("index", {
          endpoint: "obligacion",
          params: { deudor_id: deudor_id, row: 100 },
        })
        .then(async (response) => {
          for (let index = 0; index < response.datos.length; index++) {
            response.datos[index].informacion_adicional.bloqueo_gestion =
              response.datos[index].informacion_adicional.bloqueo_gestion;

            if (
              response.datos[index].condonacion_obligacion.length !==
                undefined &&
              response.datos[index].condonacion_obligacion.length > 0
            ) {
              response.datos[index].identificador_obligacion =
                response.datos[index].identificador_obligacion + "*";
            }

            response.datos[index]["interes_fga"] = 0;
            response.datos[index]["interes_fga"] = await this.getInteresesFGA(
              response.datos[index].id
            );

            response.datos[index]["saldo_real"] =
              response.datos[index]["interes_fga"] +
              response.datos[index].saldo_capital;

            let total_pagado =
              response.datos[index].informacion_adicional["pagado_capital"] !=
              undefined
                ? Number(
                    response.datos[index].informacion_adicional[
                      "pagado_capital"
                    ]
                  )
                : 0;
            total_pagado +=
              response.datos[index].informacion_adicional[
                "pagado_intereses_intermedirario"
              ] != undefined
                ? Number(
                    response.datos[index].informacion_adicional[
                      "pagado_intereses_intermedirario"
                    ]
                  )
                : 0;
            total_pagado +=
              response.datos[index].informacion_adicional[
                "pagado_otros_gastos"
              ] != undefined
                ? Number(
                    response.datos[index].informacion_adicional[
                      "pagado_otros_gastos"
                    ]
                  )
                : 0;

            if (
              response.datos[index].informacion_adicional["pagado_total"] ==
              undefined
            ) {
              response.datos[index].informacion_adicional["pagado_total"] =
                total_pagado;
            }
          }

          this.$store.dispatch("deudor/refresh_obligaciones", response.datos);
          this.buscando_obligaciones = false;
        })
        .catch((err) => {
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "Se ha presentado un error realizando su consulta",
          });
          console.log(err);
          this.buscando_obligaciones = false;
        });
    },
    async getInteresesFGA(obligacion_id) {
      try {
        let intereses_fga = await this.$store.state.api.post(
          "/utilidades/interes-fga",
          { obligacion_id: [obligacion_id] }
        );

        return intereses_fga.data.interes_fga;
      } catch (err) {
        console.log("Error tratando de consultar los intereses", err);
        return 0;
      }
    },
    clickEvent(data, slug) {
      if (slug == "paz-salvo") {
        if (
          data.informacion_adicional.generar_paz_salvo === false ||
          data.saldo_real > 0
        ) {
          this.$notify({
            title: "No se puede emitir Paz y Salvo",
            content: "No se puede emitir paz y salvo para esta obligación",
            type: "danger",
          });
          return false;
        }
      }

      if (
        (slug == "certificado-deuda" || slug == "paz-salvo") &&
        data.informacion_adicional.bloqueo_gestion
      ) {
        this.$notify({
          title: "Obligación bloqueada",
          content:
            "Esta operación no puede realizarse ya que la obligación se encuentra bloqueada",
          type: "danger",
        });
        return false;
      }

      switch (slug) {
        case "detalle-obligacion":
          this.$router.push({
            name: "ver-detalle-obligacion",
            params: { obligacion_id: data.id },
          });
          break;
        case "paz-salvo":
        case "certificado-deuda":
        case "acuerdo-pago":
          let datos = data;
          this.loading_file = true;
          this.$store
            .dispatch("gestion/generarDocumento", {
              datos: [datos],
              tipo: [slug],
              accion: "descargar",
            })
            .then((data) => {
              FileSaver.saveAs(data.data, slug + ".pdf");
              this.$notify({
                title: "Archivo descargado",
                content: "El archivo fue descargado satisfactoriamente.",
                type: "success",
              });
              this.loading_file = false;
            })
            .catch((error) => {
              this.$notify({
                title: "Fallo al descargar",
                content:
                  "Se produjo un error al tratar de descargar el archivo, por favor inténtelo mas tarde." +
                  error,
                type: "danger",
              });
              this.loading_file = false;
            });
          break;
      }
    },
  },
  mounted() {
    //parametros recibidos de gocontact
    if(this.$route.query.uuid){
      this.$store.commit("SET_UUID",this.$route.query.uuid);
      this.$store.commit("SET_OWNERID",this.$route.query.ownerid);
      this.$store.commit("SET_OWNERTYPE",this.$route.query.ownertype);
      this.$store.commit("SET_TELEFONO",this.$route.query.target);
    }
    //parametros recibidos de Wolkfox
    if(this.$route.query.agent_id){
      var telefono = this.$route.query.telefono.length >= 10 ? this.$route.query.telefono.slice(-10) : null;
      this.$store.commit("SET_AGENT_ID",this.$route.query.agent_id);
      this.$store.commit("SET_TELEFONO",telefono);
    }
    this.getDeudor(this.$route.params.documento);
  },
};
</script>
<style>
.fade:not(.show) {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-header {
  display: block;
}

.modal-title {
  font-weight: bold;
}
</style>
